import React from 'react';

import { cn } from '../../base/utils';

import type { SkeletonAnimation } from '../../skeleton/motion';

import { Skeleton } from '../Skeleton';

export interface SkeletonAvatarProps extends React.HTMLAttributes<HTMLDivElement> {
  animation?: SkeletonAnimation;
  /**
   * 头像大小
   * @default 'md'
   */
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  /**
   * 形状
   * @default 'circle'
   */
  shape?: 'circle' | 'square';
}

const sizeMap = {
  xs: 'size-6',
  sm: 'size-8',
  md: 'size-10',
  lg: 'size-12',
  xl: 'size-16',
};

/**
 * 头像骨架屏组件
 */
export function SkeletonAvatar({
  className,
  size = 'md',
  shape = 'circle',
  ...props
}: SkeletonAvatarProps) {
  return (
    <Skeleton
      className={cn(sizeMap[size], shape === 'circle' ? 'rounded-full' : 'rounded-md', className)}
      {...props}
    />
  );
}
